// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".waiter-progress-histories-tab[data-v-23bdd1dc]{position:relative}.waiter-progress-histories-tab .buttons .register-btn[data-v-23bdd1dc]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
